import { create } from 'zustand';

interface TradingUiPkg {
  version: string;
  package: string;
}

type EnvironmentSetting = Record<string, string> | null;

interface ConfigStoreState {
  environmentSettings: EnvironmentSetting;
  tradingUiPkgs: TradingUiPkg[];
  saveSettings: (data: EnvironmentSetting) => void;
  savePackages: (data: TradingUiPkg[]) => void;
}

const useConfigStore = create<ConfigStoreState>((set) => ({
  environmentSettings: null,
  tradingUiPkgs: [],
  saveSettings: (data) => set((state) => ({ ...state, environmentSettings: data })),
  savePackages: (data) => set((state) => ({ ...state, tradingUiPkgs: data })),
}));

export default useConfigStore;
